/* GoClove PLP — Init: section wiring, infinite scroll, standalone cards, boot */
(function () {
  if (window.__GOC_PLP_INIT__) return;
  window.__GOC_PLP_INIT__ = true;

  window.__GOC_PLP__ = window.__GOC_PLP__ || {};
  const GOC = window.__GOC_PLP__;

  // ---- Infinite scroll ----
  function initInfinite(root) {
    const { SELECTORS, qs } = GOC;
    if (root.__gocInfObserver) { try { root.__gocInfObserver.disconnect(); } catch (e) {} root.__gocInfObserver = null; }
    if (root.__gocInfClickBound?.btn) { try { root.__gocInfClickBound.btn.removeEventListener("click", root.__gocInfClickBound.fn); } catch (e) {} root.__gocInfClickBound = null; }

    const grid = qs(root, SELECTORS.grid);
    const inf = qs(root, SELECTORS.infiniteWrap);
    if (!grid || !inf) return;

    const btn = qs(inf, SELECTORS.loadBtn);
    const loader = qs(inf, SELECTORS.loader);
    let loading = false;

    async function loadNext(evt) {
      const loadMethod = evt && evt.type === "click" ? "load_more" : "infinite_scroll";
      const nextUrl = grid.dataset.nextUrl || "";
      if (!nextUrl || loading) return;
      loading = true;
      if (loader) loader.hidden = false;
      if (btn) btn.disabled = true;

      try {
        const { LABELS, loadSwiperOnce, bootSwipers, initCardsState } = GOC;
        const sectionHandle = grid.dataset.sectionHandle || LABELS.sectionHandle || "goc-plp-main";
        const isSearch = window.location.pathname === "/search";
        const url = new URL(nextUrl, window.location.origin);

        // For search pages: fetch the full page (section_id doesn't reliably
        // preserve the search context). For collections: use section_id as before.
        if (!isSearch) {
          url.searchParams.set("section_id", sectionHandle);
        }

        const html = await fetch(url.toString(), {
          credentials: "same-origin",
          headers: { "X-Requested-With": "XMLHttpRequest" }
        }).then(r => r.text());

        const doc = new DOMParser().parseFromString(html, "text/html");
        const newGrid = doc.querySelector(SELECTORS.grid);
        if (!newGrid) { inf.remove(); return; }
        const newChildren = Array.from(newGrid.children);
        newChildren.forEach(el => grid.appendChild(el));
        grid.dataset.nextUrl = newGrid.dataset.nextUrl || "";
        // CRO tracking hook (assets/cro-tracking.js listens for this)
        root.__gocLoadedBatches = (root.__gocLoadedBatches || 1) + 1;
        root.dispatchEvent(new CustomEvent("gocplp:appended", { bubbles: true, detail: { count: newChildren.length, method: loadMethod, batch: root.__gocLoadedBatches } }));
        loadSwiperOnce().then(() => bootSwipers(root));
        initCardsState(root);
        if (!grid.dataset.nextUrl) inf.remove();
        else if (btn) btn.disabled = false;
      } catch (e) { if (btn) btn.disabled = false; }
      finally { if (loader) loader.hidden = true; loading = false; }
    }

    if (btn) { btn.addEventListener("click", loadNext); root.__gocInfClickBound = { btn, fn: loadNext }; }
    const io = new IntersectionObserver((entries) => { if (entries[0]?.isIntersecting) loadNext(); }, { rootMargin: "600px 0px" });
    io.observe(inf);
    root.__gocInfObserver = io;
  }

  // ---- Section init ----
  function initSection(root) {
    if (root.__gocPlpInit) return;
    root.__gocPlpInit = true;

    const { SELECTORS, qsa,
      loadSwiperOnce, bootSwipers, initCardsState,
      preloadSwatchImages, applySwatchToCard,
      closeAnyDrawer, openMobileQAFromCard, closeMobileQA
    } = GOC;

    // Teleport filter drawers to <body>
    qsa(root, SELECTORS.drawer).forEach(d => { d.__gocRoot = root; document.body.appendChild(d); });

    loadSwiperOnce().then(() => bootSwipers(root));
    initInfinite(root);
    initCardsState(root);

    // theme/AJAX hook
    document.addEventListener("gocplp:updated", () => {
      initInfinite(root); initCardsState(root);
      loadSwiperOnce().then(() => bootSwipers(root));
      closeAnyDrawer(root);
    });

    // swatch hover => preload
    root.addEventListener("pointerenter", (e) => {
      const btn = e.target?.closest?.(SELECTORS.swatch);
      if (btn) preloadSwatchImages(btn);
    }, true);

    // swatch click => mutate card
    root.addEventListener("click", (e) => {
      const btn = e.target?.closest?.(SELECTORS.swatch);
      if (!btn) return; e.preventDefault();
      const card = btn.closest(SELECTORS.card);
      if (card) applySwatchToCard(btn, card);
    });

    // mobile quick add
    root.addEventListener("click", (e) => {
      const btn = e.target?.closest?.(SELECTORS.qaQuickMobile);
      if (!btn || window.innerWidth >= 990) return; e.preventDefault();
      const card = btn.closest(SELECTORS.card);
      if (card) openMobileQAFromCard(card).catch(() => {});
    });

    // gender tabs
    root.addEventListener("click", (e) => {
      const b = e.target?.closest?.("[data-gocplp-gender-btn]");
      if (!b || b.classList.contains("is-active")) return;
      const url = b.getAttribute("data-gocplp-gender-url");
      if (url) window.location.assign(url);
    });

    // size click => add to cart (desktop)
    root.addEventListener("click", async (e) => {
      const { addToCart, openCartDrawerBestEffort, QA } = GOC;
      if (QA?.el?.getAttribute("aria-hidden") === "false") return;
      const b = e.target?.closest?.(SELECTORS.sizeBtn);
      if (!b || b.classList.contains("is-disabled")) return;
      const variantId = b.getAttribute("data-variant-id") || b.dataset.variantId;
      if (!variantId) return;
      b.disabled = true;
      try { await addToCart(variantId, 1); openCartDrawerBestEffort(); }
      catch (err) { b.disabled = false; }
    });

    // ESC
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") { closeAnyDrawer(root); closeMobileQA(); }
    });

    // Filters apply
    root.addEventListener("click", (e) => {
      const applyBtn = e.target?.closest?.('.gocplp__drawer[data-goc-drawer="filters"] .gocplp__apply');
      if (!applyBtn) return; e.preventDefault(); closeAnyDrawer(root);
    });
  }

  // ---- Standalone cards ----
  function isInsidePLPRoot(el) { return !!el.closest(GOC.SELECTORS.section); }

  function initStandaloneCards() {
    const { SELECTORS, qsa, loadSwiperOnce, ensureCardSwiper,
      isNoSwatchCard, initNoSwatchCardImages, cardHasRealImage,
      applySwatchToCard, preloadSwatchImages,
      openMobileQAFromCard } = GOC;

    qsa(document, SELECTORS.card).forEach((card) => {
      if (isInsidePLPRoot(card) || card.__gocCardInit) return;
      card.__gocCardInit = true;
      loadSwiperOnce().then(() => { qsa(card, SELECTORS.swiper).forEach(ensureCardSwiper); });
      if (isNoSwatchCard(card)) initNoSwatchCardImages(card);
      else { const sw = card.querySelector(".gpcard__swatch.is-active") || card.querySelector(".gpcard__swatch"); if (sw && !cardHasRealImage(card)) applySwatchToCard(sw, card); }
    });

    if (!document.__gocStandaloneInit) {
      document.__gocStandaloneInit = true;
      document.addEventListener("pointerenter", (e) => { const btn = e.target?.closest?.(SELECTORS.swatch); if (btn && !isInsidePLPRoot(btn)) preloadSwatchImages(btn); }, true);
      document.addEventListener("click", (e) => { const btn = e.target?.closest?.(SELECTORS.swatch); if (!btn || isInsidePLPRoot(btn)) return; e.preventDefault(); const card = btn.closest(SELECTORS.card); if (card) applySwatchToCard(btn, card); });
      document.addEventListener("click", (e) => { const btn = e.target?.closest?.(SELECTORS.qaQuickMobile); if (!btn || isInsidePLPRoot(btn) || window.innerWidth >= 990) return; e.preventDefault(); const card = btn.closest(SELECTORS.card); if (card) openMobileQAFromCard(card).catch(() => {}); });
    }
  }

  window.__gocInitStandaloneCards = initStandaloneCards;

  // ---- Boot ----
  function boot() {
    const { loadLabelsFromState, bindGlobalDrawersOnce, qsa, SELECTORS } = GOC;
    loadLabelsFromState();
    bindGlobalDrawersOnce();
    qsa(document, SELECTORS.section).forEach(initSection);
    initStandaloneCards();
  }

  Object.assign(GOC, { initSection, initStandaloneCards, initInfinite });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
